import { LOCAL_STORAGE_PREFIX } from '@/constants/envs/constants'
import { ChainId } from '@/lib/chain'

export interface Store {
  getItem: (key: string) => string | null
  setItem: (key: string, val: string) => void
  removeItem: (key: string) => void
}

export function getStorageProxy(store: Storage): Store | undefined {
  try {
    store.setItem('test', '')
    store.getItem('test')
    store.removeItem('test')
  } catch (e) {
    console.warn(e)
    return undefined
  }
  return {
    getItem: (key: string) => {
      try {
        return store.getItem(key) ?? null
      } catch {
        return null
      }
    },
    setItem: (key: string, value: string) => {
      try {
        store.setItem(key, value)
      } catch (e) {
        try {
          store.clear()
          store.setItem(key, value)
        } catch {
          // Storage can be unavailable in privacy mode; keep the current session usable.
        }
      }
    },
    removeItem: (key: string) => {
      try {
        store.removeItem(key)
      } catch {
        // Ignore unavailable storage during cleanup.
      }
    }
  }
}

export let safeLocalStorage: Store | undefined
export let safeSessionStorage: Store | undefined

try {
  safeLocalStorage = getStorageProxy(localStorage)
} catch {}

try {
  safeSessionStorage = getStorageProxy(sessionStorage)
} catch {}

export const setLanguage = (lang: string) => {
  return safeLocalStorage?.setItem(`${LOCAL_STORAGE_PREFIX}.user-lang`, lang)
}
export const getLanguage = () => {
  return safeLocalStorage?.getItem(`${LOCAL_STORAGE_PREFIX}.user-lang`) || 'en'
}

export const setActiveChainId = (chainId: ChainId) => {
  return safeLocalStorage?.setItem(
    `${LOCAL_STORAGE_PREFIX}.active-chain-id`,
    chainId.toString()
  )
}

export const getActiveChainId = () => {
  return safeLocalStorage?.getItem(`${LOCAL_STORAGE_PREFIX}.active-chain-id`)
}
